let baseState = () => {
  return {
    pages: {},
    newPage: {
      id: null,
      name: '',
      group: {},
      is_published: false,
      published_at: '',
      is_robots_accessible: true,
      content: {
        slug: '',
        name: '',
        layout: {},
        layout_id: 0,
        components: [],
        json: {},
        published_at: '',
        is_published: false
      }
    },
    active: {},
    perPage: '25',
    currentPage: 1,
    totalPageCount: 1,
    totalCount: 0,
    revisions: {
      revisions: [],
      currentPage: 1,
      totalPageCount: 1,
      totalCount: 0
    },
    cardCollapsed: {
      revisions: false,
      pageSettings: false,
      metaSettings: false,
      ogSettings: false
    }
  }
}

const state = baseState()

export default state
export { baseState }
